<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="370">
    <v-card>
        <v-card-title>
           <v-icon color="primary" left>mdi-file-plus</v-icon> Driver 
           <v-spacer/>
           <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
            <v-row>
               <v-col cols="12">
                <v-form
                    ref="form"
                    class="mt-1 pa-1"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-text-field
                    v-model="driver.fullname"
                    label="Fullname"
                    :rules="textRules"
                    dense
                    outlined
                    required
                    ></v-text-field>
                   <v-text-field
                    v-model="driver.license_number"
                    label="License Number"
                    dense
                    outlined
                    ></v-text-field>
                     <v-text-field
                    v-model="driver.contact_number"
                    label="Contact Number"
                    dense
                    outlined
                    ></v-text-field>
                     <v-autocomplete
                    v-model="driver.status"
                    label="status"
                    :items="['active','deactivate']"
                    dense
                    outlined
                    />
                </v-form>
               </v-col>
                
            </v-row>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small  text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    state: {
        type: String,
        default: "new"
    },
    item: {
      type: Object,
      default: ()=>{}
    }
  },
  data: () => ({
      valid: true,
      textRules: [
        v => !!v || 'Field is required'
      ],
      discounts:[],
      discount:{},
       driver:{}
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      }
  },
  watch: {
    show(v) {
      if(v){
        if(this.state != 'new') {
        this.driver=this.item
        } else {
           this.driver={}
        }
      } 
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
          if(this.state == 'new') {
            this.Add()
          } else {
            this.Save()
          }
        }
      },
    emitToParent (action) {
       this.$emit('DialogEvent',{action:action})
    },
    Save() {
        this.$http.post("driver/update", this.driver).then(response => {
             this.GET_RESPONSE(response)
           this.$emit('DialogEvent', {action: "close"})
          }).catch(e => {
            console.log(e.data)
        })
    },
    Add() {
        this.$http.post("driver/add", this.driver).then(response => {
           this.GET_RESPONSE(response)
           this.$emit('DialogEvent', {action: "close"})
          }).catch(e => {
            console.log(e.data)
        })
    }
  }
}
</script>
